<full-calendar [options]="calendarOptions"></full-calendar>
